import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "antique"
const AntiqueIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.315 8.813C12.785 8.813 13.22 9.065 13.455 9.473L14.577 11.438H18.75C19.214 11.438 19.656 11.528 20.063 11.689V11.625C20.063 11.315 20.314 11.063 20.625 11.063 20.935 11.063 21.188 11.314 21.188 11.625V12.404C21.88 13.054 22.313 13.976 22.313 15V16.154C22.313 16.655 21.905 17.063 21.403 17.063H20.454C20.074 18.049 19.118 18.75 18 18.75 16.88 18.75 15.925 18.05 15.548 17.063H9.202C8.825 18.049 7.87 18.75 6.75 18.75 5.63 18.75 4.675 18.05 4.298 17.063H2.659C2.123 17.063 1.688 16.627 1.688 16.09V15C1.688 13.1 3.175 11.547 5.049 11.443L7.392 9.622C8.066 9.097 8.896 8.812 9.75 8.812zM6.75 15C6.129 15 5.625 15.504 5.625 16.125S6.129 17.25 6.75 17.25 7.875 16.746 7.875 16.125 7.371 15 6.75 15M18 15C17.379 15 16.875 15.504 16.875 16.125S17.379 17.25 18 17.25 19.125 16.746 19.125 16.125 18.621 15 18 15M13.67 16.638V16.636zM18.676 12.565C18.621 12.567 18.536 12.572 18.431 12.583 18.218 12.604 17.917 12.647 17.574 12.733 16.88 12.907 16.05 13.246 15.398 13.898 14.698 14.598 14.262 15.296 14.003 15.814L13.943 15.937H15.384C15.48 14.576 16.613 13.5 18 13.5S20.52 14.575 20.617 15.938H21.187V15C21.188 13.654 20.098 12.563 18.75 12.563H18.737Q18.717 12.563 18.676 12.565M5.25 12.563C4.387 12.563 3.63 13.01 3.196 13.687H3.375C3.685 13.688 3.938 13.94 3.938 14.25S3.686 14.813 3.375 14.813H2.821Q2.813 14.905 2.812 15V15.938H4.134C4.23 14.575 5.363 13.5 6.75 13.5S9.27 14.575 9.367 15.938H12.723C12.787 15.768 12.875 15.555 12.997 15.31 13.3 14.704 13.802 13.902 14.602 13.102Q14.91 12.797 15.244 12.562zM9.188 9.998C8.788 10.083 8.408 10.256 8.082 10.51L6.89 11.438H9.187zM10.312 11.438H13.28L12.477 10.032C12.445 9.974 12.382 9.938 12.315 9.937H10.313z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default AntiqueIcon
